/* eslint-disable linebreak-style */

import { AppKeyType } from './appKey-type';

// Dev uat = Development
const appIdKey_uat = [
  {
    appId: '253a5b70-dda8-475e-ba57-8a2061c25767',
    name: 'RTC-DOUALA', // RTC DOUALA
    secretKey: process.env.REACT_APP_EVISA_SECKEY ?? '',
  },
  {
    appId: '5d12644e-8216-89dc-4fb4-4j7b972320d2',
    name: 'E-VISA',
    secretKey: process.env.REACT_APP_EVISA_SECKEY ?? '',
  },
  {
    appId: '5d12644e-8216-4fb4-89dc-4e9b972310c4',
    name: 'DEMO-DBS',
    secretKey: process.env.REACT_APP_EVISA_SECKEY ?? '',
  },
  {
    appId: '95db62f8-b80d-443a-b4ee-149d698c703c',
    name: 'PASSCAM',
    secretKey: process.env.REACT_APP_PASSCAM_SECKEY ?? '',
  },
  {
    appId: '3e766ce8-84a7-4a70-8100-5455aed61eca',
    name: 'CAMWATER',
    secretKey: process.env.REACT_APP_PASSCAM_SECKEY ?? '',
  },
  {
    appId: 'a490ebd2-ba23-4158-98be-1101b5f4ee57',
    name: 'KEYCE_INFORMATIQUE',
    secretKey: process.env.REACT_APP_PASSCAM_SECKEY ?? '',
  },
  {
    appId: '80b67759-228d-4219-ab9d-75066129c6f3',
    name: 'RTC MM DOUALA',
    secretKey: 'FLWSECK-916f99e5de6779cc97364ffe81e9bd31-1a0349f7464vt-X',
  },
];

// Demo: Test
const appIdKey_demo = [
  {
    appId: '5d12644e-8216-89dc-4fb4-4j7b972320d2',
    name: 'E-VISA',
    secretKey: process.env.REACT_APP_EVISA_SECKEY ?? '',
  },
];

// Production: Prod
const appIdKey_prod = [
  {
    appId: '5d12644e-8216-4fb4-89dc-4e9b972310c4',
    name: 'E-VISA',
    secretKey: process.env.REACT_APP_EVISA_SECKEY ?? '',
  },
  // {
  //   appId: '95db62f8-b80d-443a-b4ee-149d698c703c',
  //   name: 'PASSCAM',
  //   secretKey: process.env.REACT_APP_PASSCAM_SECKEY ?? '',
  // },
  {
    appId: '782f6206-e093-4219-bccc-d6b427e5ce98',
    name: 'AUGENTIC', // PASSCAM
    secretKey: process.env.REACT_APP_PASSCAM_SECKEY ?? '',
    // secretKey: process.env.REACT_APP_EVISA_SECKEY ?? '',
    // secretKey: process.env.REACT_APP_PASSCAM_SECKEY ?? '',
  },
  {
    appId: '1d3d209b-76d6-447f-a1e1-3c2a0784e402',
    name: 'CAMWATER', // CONGRES AAEA 2026
    secretKey: process.env.REACT_APP_EVISA_SECKEY ?? '',
  },
  {
    appId: '3a2a8a97-3bb4-4195-8728-d993977a5747',
    name: 'RTC_APP', // RTC APP
    secretKey: process.env.REACT_APP_EVISA_SECKEY ?? '',
  },
];

/**
 * Liste des appId / clés : au build, CRA force NODE_ENV=production.
 * Utilise REACT_APP_APP_KEYS_MODE (même valeur que NODE_ENV dans .env : development | production | test).
 */
const appKeysMode = process.env.REACT_APP_APP_KEYS_MODE ?? process.env.NODE_ENV;

const appIdKey: AppKeyType[] = [];
switch (appKeysMode) {
  case 'development':
    appIdKey.push(...appIdKey_uat);
    break;
  case 'production':
    appIdKey.push(...appIdKey_prod);
    break;
  case 'test':
    appIdKey.push(...appIdKey_demo);
    break;
  default:
    appIdKey.push(...appIdKey_uat);
    break;
}
export { appIdKey };
